import React, { useEffect, useRef, useState } from 'react';
import { cn } from '../../../../../../utils/styles';
import AccountFeature from '../Feature';
import { NotifyTypeEnum } from '../../../../Layout/Account/Data';
import { Input } from '../../../../../../components/Common/UI/Input';
import { IAccountInfo } from '../Delivery';

const emailStyles =
  'border-[#F4855E] text-[#F4855E] ' +
  'hover:bg-[#F4855E] hover:text-white data-[active=true]:bg-[#F4855E] data-[active=true]:text-white';
const emailAndTextsStyles =
  'border-primary text-primary ' +
  'hover:bg-primary hover:text-white data-[active=true]:bg-primary data-[active=true]:text-white';

const regex = /^\d*$/;

function AccountNotify({ label, isEdit, account, handleUpdate }: IAccountInfo) {
  const [showSecondEmail, setShowSecondEmail] = useState(Boolean(account.secondEmail));
  const secondEmailRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (showSecondEmail && secondEmailRef.current) {
      secondEmailRef.current.focus();
    }
  }, [showSecondEmail]);

  useEffect(() => {
    if (!account.secondEmail) {
      setShowSecondEmail(false);
    }
  }, [account.secondEmail]);

  return (
    <div>
      <div className="flex gap-[10px]">
        <div className="xl:min-w-[120px] min-w-[100px] text-[12px] uppercase font-medium opacity-60 text-addition1">
          {label}
        </div>
        {!isEdit ? (
          <AccountFeature
            active
            accountKey="notify"
            value={account.notify}
            className={cn('cursor-auto', account.notify === NotifyTypeEnum.email ? emailStyles : emailAndTextsStyles)}
          />
        ) : (
          <div>
            <div className="flex flex-wrap gap-[5px] mb-[5px]">
              <AccountFeature
                active={account.notify === NotifyTypeEnum.email}
                accountKey="notify"
                value={NotifyTypeEnum.email}
                className={emailStyles}
                handleUpdate={handleUpdate}
              />
              <AccountFeature
                active={account.notify === NotifyTypeEnum.emailTexts}
                accountKey="notify"
                value={NotifyTypeEnum.emailTexts}
                className={emailAndTextsStyles}
                handleUpdate={handleUpdate}
              />
            </div>
          </div>
        )}
      </div>
      {isEdit ? (
        <div className="mt-[5px]">
          <Input
            prefix="Email"
            variant="guidance"
            sizeVariant="lg"
            value={account.email}
            onChange={e => handleUpdate(e.target.value, 'email')}
          />
          {!showSecondEmail && (
            <AccountFeature
              value="ADD EMAIL"
              className="mt-[8px] px-3 py-0 h-[20px] text-primary border-primary hover:bg-primary hover:text-white"
              accountKey="secondEmail"
              active={false}
              handleUpdate={() => setShowSecondEmail(true)}
            />
          )}

          {showSecondEmail && (
            <Input
              prefix="Second Email"
              variant="guidance"
              className="mt-[10px]"
              sizeVariant="lg"
              value={account.secondEmail || ''}
              onChange={e => {
                handleUpdate(e.target.value, 'secondEmail');
                setShowSecondEmail(true);
              }}
              ref={secondEmailRef}
            />
          )}

          {account.notify === NotifyTypeEnum.emailTexts ? (
            <Input
              prefix="Phone"
              variant="guidance"
              className="mt-[10px]"
              sizeVariant="lg"
              value={account.phone}
              onChange={e => {
                if (regex.test(e.target.value) && e.target.value.length <= 12) {
                  handleUpdate(e.target.value, 'phone');
                }
              }}
            />
          ) : null}
        </div>
      ) : (
        <div className="flex gap-[10px] mt-[10px] items-start">
          <div className="xl:min-w-[120px] min-w-[100px] text-[12px] uppercase font-medium opacity-60 text-addition1">
            EMAIL
          </div>

          <div className="flex flex-col gap-2 flex-1">
            <Input
              readOnly
              value={account.email}
              inputClassName="h-[26px] p-[5px_8px] pointer-events-none rounded-[3px]"
            />
            {account.secondEmail && (
              <Input
                readOnly
                value={account.secondEmail}
                inputClassName="h-[26px] p-[5px_8px] pointer-events-none rounded-[3px]"
              />
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default AccountNotify;
